import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL,
    FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
    FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL
} from '../actions/hillScoreActions';

// Workers
export function* fetchDailyHillScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate, endDate, isOneDay } = action.payload;
        const url = isOneDay
            ? `metrics-service/metrics/hillscore?calendarDate=${startDate}`
            : `metrics-service/metrics/hillscore/stats?startDate=${startDate}&endDate=${endDate}&aggregation=daily`;
        const response = yield call(gcApi.get, url);
        // same aggregation is used for 1 day and 4 weeks, this is to prevent data changing between different screens (i.e. widgets)
        if (isOneDay) {
            yield put({
                type: FETCH_DAILY_HILL_SCORE_DATA_ONE_DAY_REPORTS_SUCCESS,
                hillScoreData: response.data
            });
        } else {
            yield put({
                type: FETCH_DAILY_HILL_SCORE_DATA_REPORTS_SUCCESS,
                hillScoreData: response.data
            });
        }
    } catch (e) {
        yield put({
            type: FETCH_DAILY_HILL_SCORE_DATA_REPORTS_FAIL,
            hillScoreData: null
        });
    }
}

export function* fetchWeeklyHillScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(
            gcApi.get,
            `metrics-service/metrics/hillscore/stats?startDate=${startDate}&endDate=${endDate}&aggregation=weekly`
        );

        yield put({
            type: FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
            hillScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS_FAIL,
            hillScoreData: null
        });
    }
}

export function* fetchMonthlyHillScoreDataSaga(action) {
    try {
        yield put({
            type: FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FETCHING
        });

        const { startDate, endDate } = action.payload;
        const response = yield call(
            gcApi.get,
            `metrics-service/metrics/hillscore/stats?startDate=${startDate}&endDate=${endDate}&aggregation=monthly`
        );

        yield put({
            type: FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_SUCCESS,
            hillScoreData: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS_FAIL,
            hillScoreData: null
        });
    }
}

// Watcher
export const hillScoreReportsSagas = [
    takeEvery(FETCH_WEEKLY_HILL_SCORE_DATA_REPORTS, fetchWeeklyHillScoreDataSaga),
    takeEvery(FETCH_MONTHLY_HILL_SCORE_DATA_REPORTS, fetchMonthlyHillScoreDataSaga),
    takeEvery(FETCH_DAILY_HILL_SCORE_DATA_REPORTS, fetchDailyHillScoreDataSaga)
];
